exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-page-shell[data-v-186cae33]{padding:18px}.list-page-shell__heading[data-v-186cae33]{margin-bottom:8px;font-size:16px;font-weight:600;color:#303133}.list-page-shell__hint[data-v-186cae33]{margin:0 0 16px;font-size:13px;color:#909399;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-186cae33","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ListPageShell.vue
// module id = Xx9z
// module chunks = 0